export type AccountDataDraft = {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  dateOfBirth?: string; /** Server format: YYYY-MM-DD */
  birthday?: string; /** Display mask: MM / DD / YYYY */
  // Legacy customerProfile aggregate booleans — true iff the user has checked
  // the corresponding legal-document group (terms_of_use / informed_consent_for_telehealth_services).
  // Sent on createUser / updateCustomerProfile alongside `signedDocuments`.
  terms?: boolean;
  consent?: boolean;
  sms?: boolean;
  // Per-document signature events. Includes the anchor + every linked doc of
  // each checked group, so the server records a signature for each. Source of
  // truth; `terms` / `consent` are derived from this and the catalog.
  signedDocuments?: { uuid: string }[];
  // password?: never persist in RulesEngine
  userUuid?: string;
  isTester?: boolean;
};

export type EligibilityDataDraft = {
  orgKey?: string;
  orgUuid?: string;
  orgName?: string;
  orgEligibilityCheckFields?: string;
  gender?: string;
  inviteCode?: string;
  employeeId?: string;
  insuranceId?: string;
  zipCode?: string;
  healthPlanUuid?: string;
  selectHealthPlan?: boolean;
  healthPlanHolderRelation?: 'self' | 'spouse' | 'dependent' | string;
  healthPlanHolderFirstName?: string;
  healthPlanHolderLastName?: string;
  healthPlanHolderBirthday?: string;
  healthPlanHolderGender?: string;
};

export type ProfileDataDraft = {
  ethnicity?: string;
  height?: number;
  weight?: number;
};

export type OnboardingDataDraft = AccountDataDraft & EligibilityDataDraft & ProfileDataDraft;
